import { actions as externalUploadersActions } from '../../slices/externalUploadersSlice';
import { PdpDispatch, PdpState } from '../../store';
import { tryPollExternalUploads } from './tryPollExternalUploads';

export const externalUploadPoller: ExternalUploaderPoller = {

    activate: (getState, dispatch, { msInterval }) => {

        externalUploadPoller
            .addPollListener(createUpdateImageCountListener(dispatch));

        const pollOnTimeout = () => {
            setTimeout(async () => {
                const state = getState();
                await tryPollExternalUploads(state, dispatch);
                pollOnTimeout();
            }, msInterval);
        };

        pollOnTimeout();
    },

    updatedOn: undefined,

    handlers: [],
    addPollListener: (handler) => {
        externalUploadPoller.handlers.push(handler);
    }
};

type ExternalUploaderPoller = {

    activate: (
        getState: () => PdpState,
        dispatch: PdpDispatch,
        options: { msInterval: number }
    ) => void;

    updatedOn: number | undefined;

    handlers: ExternalUploaderPollHandler<any>[];
    addPollListener: (handler: ExternalUploaderPollHandler<any>) => void;
};

export type ExternalUploaderPollHandler<TPayload> = (
    assets: ExternalUploadAsset<TPayload>[]
) => void;

export type ExternalUploadAsset<TPayload> = {

    assetId: string;
    url: string;
    fileName: string;

    externalUploaderId: string;
    externalUploaderPayload: TPayload;

    meta: any;
};

const createUpdateImageCountListener = (
    dispatch: PdpDispatch
): ExternalUploaderPollHandler<any> => {
    return (assets) => dispatch(externalUploadersActions.updateImageCount(assets));
};